import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/dist/query";
import { earningApi } from "../Services/earningApi";
import themeReducer from "../Services/themeSlice";
import { topupApi } from "../Services/topupApi";
import { userApi } from "../Services/userApi";
import { walletApi } from "../Services/walletApi";
import { depositeApi } from "../Services/depositeApi";
import { withdrawApi } from "../Services/withdrawApi";
import { supportApi } from "../Services/SupportApi";
import { settingApi } from "../Services/Setting";
import { contactUsMessage } from "../Services/contactUsMessage";

export const store = configureStore({
  reducer: {
    theme: themeReducer,
    [userApi.reducerPath]: userApi.reducer,
    [walletApi.reducerPath]: walletApi.reducer,
    [earningApi.reducerPath]: earningApi.reducer,
    [withdrawApi.reducerPath]: withdrawApi.reducer,
    [depositeApi.reducerPath]: depositeApi.reducer,
    [topupApi.reducerPath]: topupApi.reducer,
    [supportApi.reducerPath]: supportApi.reducer,
    [settingApi.reducerPath]: settingApi.reducer,
    [contactUsMessage.reducerPath]: contactUsMessage.reducer,
    /** here will be more reducer */
  },
  devTools: false,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat([
      userApi.middleware,
      earningApi.middleware,
      topupApi.middleware,
      walletApi.middleware,
      depositeApi.middleware,
      withdrawApi.middleware,
      supportApi.middleware,
      settingApi.middleware, 
      contactUsMessage.middleware, 
    ]),
  /** here will be more reducer */
});

setupListeners(store.dispatch);
